class StickyMenu {
    // 1. describe and create/initiate our object
    constructor() {
        this.header = document.querySelector("header");
        this.scrollOffSet = 50;
        this.events();
    }

    // 2. events
    events() {
       window.addEventListener('scroll', () => this.runSticky());
    }

     // 3. methods (function, action...)
     runSticky() {
        if (window.scrollY > 50) {
            this.header.classList.add('header-fixed');
        
        } else {
            this.header.classList.remove('header-fixed');
        }
     }
}



export default StickyMenu;